module.exports = "<div class=\"subscriptions-typeahead-result clearfix\" ng-click=\"::context.onAdd(data)\">\n    {{ ::data.name }}\n</div>\n";